import logger from 'ws-scripts/modules/logger';

export function formatCurrency(
	num,
	locale = 'en_US',
	showFractionDigits = false
) {
	const options = {
		style: locale === 'fr_CA' ? 'decimal' : 'currency',
		currency: locale.length && locale.indexOf('CA') > -1 ? 'CAD' : 'USD'
	};

	let currencyValue;
	if (typeof num !== 'number') {
		logger.warn(
			`formatCurrency: unexpected currency value: ${num} of type ${typeof num}`
		);
		return '';
	}

	if (showFractionDigits) {
		// two fraction digits by default
		currencyValue = num;
	} else {
		currencyValue = Math.round(num);
		options.minimumFractionDigits = 0;
	}

	const final = new Intl.NumberFormat(
		locale.replace('_', '-'),
		options
	).format(currencyValue);

	if (locale === 'fr_CA') {
		return `${final} $`;
	} else {
		return final;
	}
}



// WEBPACK FOOTER //
// ./src/utils/utility.js